// ============================================
// CENTROAGENTES.JS — Centro de control "botitos animados"
// ============================================
import React, { useState, useEffect, useMemo } from 'react';

const PP = "'Poppins', sans-serif";

const AGENTES = [
  { id:'beep', nombre:'Beep', rol:'Director de Orquesta', emoji:'🎯',
    bg:'#0C447C', bgBot:'rgba(255,255,255,.15)', eyeColor:'#7dd3fc',
    nameColor:'#fff', roleColor:'rgba(255,255,255,.7)', esCEO:true },
  { id:'axel', nombre:'Axel', rol:'Comercial', emoji:'💼',
    bg:'#E1F5EE', bgBot:'#9FE1CB', eyeColor:'#085041',
    nameColor:'#085041', roleColor:'#0F6E56', btnBg:'#0F6E56' },
  { id:'max', nombre:'Max', rol:'Operaciones', emoji:'⚙️',
    bg:'#FAEEDA', bgBot:'#FAC775', eyeColor:'#412402',
    nameColor:'#412402', roleColor:'#633806', btnBg:'#633806' },
  { id:'rex', nombre:'Rex', rol:'Proyectos', emoji:'🏗️',
    bg:'#E1F5EE', bgBot:'#5DCAA5', eyeColor:'#04342C',
    nameColor:'#04342C', roleColor:'#085041', btnBg:'#085041' },
  { id:'bruno', nombre:'Bruno', rol:'Almacén', emoji:'📦',
    bg:'#EEEDFE', bgBot:'#D3D1C7', eyeColor:'#2C2C2A',
    nameColor:'#2C2C2A', roleColor:'#444441', btnBg:'#444441' },
  { id:'nova', nombre:'Nova', rol:'Administración', emoji:'📋',
    bg:'#FBEAF0', bgBot:'#ED93B1', eyeColor:'#4B1528',
    nameColor:'#4B1528', roleColor:'#72243E', btnBg:'#72243E' },
  { id:'luna', nombre:'Luna', rol:'Marketing', emoji:'✨',
    bg:'#FAEEDA', bgBot:'#FAC775', eyeColor:'#412402',
    nameColor:'#412402', roleColor:'#633806', btnBg:'#633806', esLuna:true },
];

const ESTILOS_GLOBAL = `
@keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
@keyframes float2 { 0%,100%{transform:translateY(-3px)} 50%{transform:translateY(3px)} }
@keyframes pulse-ring { 0%{box-shadow:0 0 0 0 rgba(29,158,117,0.4)} 70%{box-shadow:0 0 0 8px rgba(29,158,117,0)} 100%{box-shadow:0 0 0 0 rgba(29,158,117,0)} }
@keyframes shake { 0%,100%{transform:rotate(0)} 25%{transform:rotate(-8deg)} 75%{transform:rotate(8deg)} }
@keyframes typing-dot { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }
@keyframes slideUp { from{transform:translateY(100%)} to{transform:translateY(0)} }
@keyframes fadeIn { from{opacity:0} to{opacity:1} }
`;

function leer(key, def) {
  try { const r = localStorage.getItem(key); return r ? JSON.parse(r) : def; } catch { return def; }
}

function generarEstado(id) {
  const servicios = leer('beep_servicios', []);
  const proyectos = leer('beep_proyectos', []);
  const cotizaciones = leer('beep_cotizaciones_pipeline', []);
  const gastos = leer('beep_gastos', []);
  const tareas = leer('beep_tareas', []);
  const aprobaciones = leer('beep_aprobaciones', []);

  switch (id) {
    case 'beep': {
      const pendientes = aprobaciones.filter(a => a.estado === 'pendiente').length;
      return {
        estado: pendientes > 0 ? 'alerta' : 'activo',
        actividad: pendientes > 0 ? `${pendientes} aprobaciones esperando a Ricardo` : 'Monitoreando todos los departamentos',
        stats: [
          { v: tareas.length, l: 'tareas' },
          { v: cotizaciones.length, l: 'cotiz.' },
          { v: pendientes, l: 'alertas' },
        ],
      };
    }
    case 'axel': {
      const cotizActivas = cotizaciones.filter(c => !['ganada','perdida','vencida'].includes(c.estado || c.estadoCalculado));
      return {
        estado: cotizActivas.length > 0 ? 'procesando' : 'espera',
        actividad: cotizActivas.length > 0 ? `${cotizActivas.length} cotizaciones activas` : 'Sin cotizaciones activas',
        stats: [
          { v: cotizActivas.length, l: 'activas' },
          { v: cotizaciones.filter(c => c.estado === 'ganada').length, l: 'ganadas' },
        ],
      };
    }
    case 'max': {
      const serviciosHoy = servicios.filter(s => ['en_proceso','en_sitio','en_camino'].includes(s.estado));
      return {
        estado: serviciosHoy.length > 0 ? 'activo' : 'espera',
        actividad: serviciosHoy.length > 0 ? `${serviciosHoy.length} servicios en campo ahora` : 'Sin servicios activos hoy',
        stats: [
          { v: serviciosHoy.length, l: 'en campo' },
          { v: servicios.filter(s => s.estado === 'completado').length, l: 'completados' },
        ],
      };
    }
    case 'rex': {
      const proyActivos = proyectos.filter(p => ['en_ejecucion','anticipo','aprobado'].includes(p.estado));
      return {
        estado: proyActivos.length > 0 ? 'activo' : 'espera',
        actividad: proyActivos.length > 0 ? `${proyActivos.length} proyectos en ejecución` : 'Sin proyectos activos',
        stats: [
          { v: proyActivos.length, l: 'activos' },
          { v: proyectos.filter(p => p.estado === 'cotizacion').length, l: 'en cotiz.' },
        ],
      };
    }
    case 'bruno': {
      const inv = leer('beep_inventario', []);
      const bajos = inv.filter(i => i.cantidad <= i.cantidadMinima);
      return {
        estado: bajos.length > 0 ? 'alerta' : 'espera',
        actividad: bajos.length > 0 ? `${bajos.length} artículos con stock bajo` : 'Inventario en orden',
        stats: [
          { v: inv.length, l: 'artículos' },
          { v: bajos.length, l: 'stock bajo' },
        ],
      };
    }
    case 'nova': {
      const gastosPend = gastos.filter(g => g.estado === 'pendiente');
      return {
        estado: gastosPend.length > 0 ? 'activo' : 'espera',
        actividad: gastosPend.length > 0 ? `${gastosPend.length} gastos pendientes de aprobar` : 'Sin gastos pendientes',
        stats: [{ v: gastosPend.length, l: 'pendientes' }],
      };
    }
    case 'luna': {
      const aprobPend = aprobaciones.filter(a => a.estado === 'pendiente' && a.agente === 'luna');
      return {
        estado: aprobPend.length > 0 ? 'espera' : 'activo',
        actividad: aprobPend.length > 0 ? 'Campaña esperando aprobación de Ricardo' : 'Monitoreando marketing',
        stats: [{ v: aprobPend.length, l: 'por aprobar' }],
      };
    }
    default:
      return { estado: 'espera', actividad: 'Sin actividad reciente', stats: [] };
  }
}

function historialAgente(id) {
  const out = [];
  if (id === 'max') {
    leer('beep_servicios', []).forEach(s => (s.historial || []).slice(-1).forEach(h => out.push({ ref: s.folio, accion: h.accion, fecha: h.fecha })));
  } else if (id === 'rex') {
    leer('beep_proyectos', []).forEach(p => (p.historial || []).slice(-1).forEach(h => out.push({ ref: p.folio, accion: h.accion, fecha: h.fecha })));
  } else if (id === 'nova') {
    leer('beep_gastos', []).forEach(g => out.push({ ref: g.folio, accion: `Gasto ${g.estado}: $${g.monto}`, fecha: g.fecha }));
  } else if (id === 'axel') {
    leer('beep_cotizaciones_pipeline', []).forEach(c => out.push({ ref: c.folio, accion: `Cotización ${c.estado || ''}`, fecha: c.fechaCreacion || c.fecha }));
  } else if (id === 'bruno') {
    leer('beep_inventario', []).filter(i => i.cantidad <= i.cantidadMinima).forEach(i => out.push({ ref: i.codigo || i.nombre, accion: `Stock bajo: ${i.cantidad}`, fecha: new Date().toISOString() }));
  } else if (id === 'beep') {
    leer('beep_aprobaciones', []).filter(a => a.estado === 'pendiente').forEach(a => out.push({ ref: a.folio, accion: a.titulo, fecha: a.fechaCreacion }));
  } else if (id === 'luna') {
    leer('beep_aprobaciones', []).filter(a => a.agente === 'luna').forEach(a => out.push({ ref: a.folio, accion: a.titulo, fecha: a.fechaCreacion }));
  }
  out.sort((a, b) => new Date(b.fecha || 0) - new Date(a.fecha || 0));
  return out.slice(0, 3);
}

function tiempoRel(iso) {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  const min = Math.floor(ms / 60000);
  if (min < 1) return 'ahora';
  if (min < 60) return `hace ${min}m`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h}h`;
  return `hace ${Math.floor(h / 24)}d`;
}

const tieneAcceso = (rol) => {
  if (!rol) return false;
  const r = rol.toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
  return ['direccion', 'administracion', 'administrador', 'admin'].includes(r);
};

function abrirAgente(id) {
  window.dispatchEvent(new CustomEvent('beep:abrir-agente', { detail: id }));
}

// ====== Sub-componentes visuales ======

function Ojos({ color, durmiendo }) {
  if (durmiendo) {
    return (
      <div style={{ display: 'flex', gap: 10 }}>
        <div style={{ width: 10, height: 3, borderRadius: 2, background: color }} />
        <div style={{ width: 10, height: 3, borderRadius: 2, background: color }} />
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', gap: 10 }}>
      <div style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
      <div style={{ width: 8, height: 8, borderRadius: '50%', background: color }} />
    </div>
  );
}

function BadgeEstado({ estado }) {
  const map = {
    activo: { bg: '#D1FAE5', fg: '#065F46', txt: 'Activo' },
    procesando: { bg: '#FEF3C7', fg: '#92400E', txt: 'Procesando' },
    espera: { bg: '#E5E7EB', fg: '#4B5563', txt: 'En espera' },
    alerta: { bg: '#FEE2E2', fg: '#991B1B', txt: '⚠️ Alerta' },
  };
  const s = map[estado] || map.espera;
  return (
    <span style={{
      background: s.bg, color: s.fg,
      fontSize: 10, fontWeight: 700, padding: '3px 9px',
      borderRadius: 999, display: 'inline-flex', alignItems: 'center', gap: 5,
      animation: estado === 'alerta' ? 'pulse-ring 1.6s ease-out infinite' : 'none',
    }}>
      {estado === 'procesando' && (
        <span style={{ display: 'inline-flex', gap: 2 }}>
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              width: 4, height: 4, borderRadius: '50%', background: s.fg,
              animation: `typing-dot 1s ease-in-out infinite`, animationDelay: `${i * 0.15}s`,
            }} />
          ))}
        </span>
      )}
      {s.txt}
    </span>
  );
}

function Botito({ agente, estado, animDelay }) {
  const durmiendo = estado === 'espera';
  const animName = estado === 'procesando' ? 'shake' : (estado === 'alerta' ? 'float2' : 'float');
  const animDur = estado === 'procesando' ? '0.6s' : '3.2s';
  return (
    <div style={{
      width: 78, height: 78, borderRadius: '50%',
      background: agente.bgBot,
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      gap: 6, flexShrink: 0,
      animation: `${animName} ${animDur} ease-in-out infinite`,
      animationDelay: `${animDelay}s`,
      border: agente.esCEO ? '2px solid rgba(255,255,255,0.25)' : 'none',
    }}>
      <Ojos color={agente.eyeColor} durmiendo={durmiendo} />
      <div style={{ fontSize: 18, lineHeight: 1 }}>{agente.emoji}</div>
    </div>
  );
}

function CardAgente({ agente, data, animDelay, movil, onAbrirModal, onNavegar }) {
  const ceo = agente.esCEO;
  return (
    <div
      onClick={() => onAbrirModal(agente)}
      style={{
        background: agente.bg,
        borderRadius: 20,
        padding: movil ? 16 : 18,
        cursor: 'pointer',
        display: 'flex', flexDirection: 'column', gap: 12,
        boxShadow: ceo ? '0 8px 28px rgba(12,68,124,0.35)' : '0 4px 14px rgba(0,0,0,0.06)',
        transition: 'transform 0.2s',
        maxWidth: '100%', boxSizing: 'border-box', overflow: 'hidden',
      }}
      onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
    >
      <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
        <Botito agente={agente} estado={data.estado} animDelay={animDelay} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: ceo ? 20 : 17, fontWeight: 800, color: agente.nameColor, lineHeight: 1.1 }}>
            {agente.nombre}
          </div>
          <div style={{ fontSize: 11, color: agente.roleColor, fontWeight: 600, marginTop: 2, textTransform: 'uppercase', letterSpacing: 0.4 }}>
            {agente.rol}
          </div>
          <div style={{ marginTop: 6 }}>
            <BadgeEstado estado={data.estado} />
          </div>
        </div>
      </div>

      <div style={{
        fontSize: 12, color: agente.nameColor, opacity: 0.85,
        background: ceo ? 'rgba(255,255,255,0.10)' : 'rgba(255,255,255,0.55)',
        borderRadius: 12, padding: '8px 12px',
        wordBreak: 'break-word',
      }}>
        {data.actividad}
      </div>

      {data.stats.length > 0 && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${data.stats.length}, 1fr)`,
          gap: 8,
        }}>
          {data.stats.map((s, i) => (
            <div key={i} style={{
              background: ceo ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.6)',
              borderRadius: 10, padding: '8px 6px', textAlign: 'center', minWidth: 0,
            }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: agente.nameColor, lineHeight: 1 }}>{s.v}</div>
              <div style={{ fontSize: 9, color: agente.roleColor, fontWeight: 600, textTransform: 'uppercase', marginTop: 3 }}>{s.l}</div>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={(e) => {
          e.stopPropagation();
          if (onNavegar) onNavegar('mitrabajo.agentes-chat', agente.id);
          else abrirAgente(agente.id);
        }}
        style={{
          width: '100%', padding: '10px 14px',
          background: ceo ? 'rgba(255,255,255,0.18)' : (agente.btnBg || '#000'),
          color: ceo ? '#fff' : '#fff',
          border: ceo ? '1px solid rgba(255,255,255,0.35)' : 'none',
          borderRadius: 12, fontSize: 13, fontWeight: 700,
          cursor: 'pointer', fontFamily: PP,
        }}
      >
        💬 Abrir chat
      </button>
    </div>
  );
}

function ModalAgente({ agente, onClose, movil }) {
  if (!agente) return null;
  const data = generarEstado(agente.id);
  const hist = historialAgente(agente.id);
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9998,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
        animation: 'fadeIn 0.2s ease-out',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: agente.bg,
          width: '100%', maxWidth: 520,
          borderTopLeftRadius: 24, borderTopRightRadius: 24,
          padding: movil ? 18 : 24,
          maxHeight: '85vh', overflowY: 'auto',
          animation: 'slideUp 0.3s ease-out',
          fontFamily: PP,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <div style={{ width: 40, height: 4, borderRadius: 2, background: 'rgba(0,0,0,0.15)' }} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%', background: agente.bgBot,
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30,
            animation: 'float 3s ease-in-out infinite',
          }}>{agente.emoji}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 800, color: agente.nameColor }}>{agente.nombre}</div>
            <div style={{ fontSize: 11, color: agente.roleColor, fontWeight: 700, textTransform: 'uppercase' }}>{agente.rol}</div>
            <div style={{ marginTop: 6 }}><BadgeEstado estado={data.estado} /></div>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(0,0,0,0.08)', border: 'none', width: 32, height: 32,
            borderRadius: '50%', fontSize: 18, cursor: 'pointer', color: agente.nameColor,
          }}>×</button>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.6)', borderRadius: 14,
          padding: 14, marginBottom: 14,
        }}>
          <div style={{ fontSize: 10, color: agente.roleColor, fontWeight: 700, textTransform: 'uppercase', marginBottom: 4 }}>
            Actividad actual
          </div>
          <div style={{ fontSize: 14, color: agente.nameColor, fontWeight: 600 }}>{data.actividad}</div>
        </div>

        {data.stats.length > 0 && (
          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${data.stats.length}, 1fr)`,
            gap: 8, marginBottom: 14,
          }}>
            {data.stats.map((s, i) => (
              <div key={i} style={{
                background: 'rgba(255,255,255,0.6)', borderRadius: 12,
                padding: '12px 8px', textAlign: 'center',
              }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: agente.nameColor }}>{s.v}</div>
                <div style={{ fontSize: 10, color: agente.roleColor, fontWeight: 600, textTransform: 'uppercase', marginTop: 4 }}>{s.l}</div>
              </div>
            ))}
          </div>
        )}

        <div style={{
          background: 'rgba(255,255,255,0.6)', borderRadius: 14,
          padding: 14, marginBottom: 16,
        }}>
          <div style={{ fontSize: 10, color: agente.roleColor, fontWeight: 700, textTransform: 'uppercase', marginBottom: 8 }}>
            Últimas acciones
          </div>
          {hist.length === 0 ? (
            <div style={{ fontSize: 12, color: agente.roleColor, fontStyle: 'italic' }}>Sin actividad registrada</div>
          ) : hist.map((h, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', gap: 10,
              padding: '6px 0',
              borderBottom: i < hist.length - 1 ? '1px solid rgba(0,0,0,0.08)' : 'none',
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: agente.nameColor }}>{h.ref}</div>
                <div style={{ fontSize: 11, color: agente.roleColor, wordBreak: 'break-word' }}>{h.accion}</div>
              </div>
              <div style={{ fontSize: 10, color: agente.roleColor, whiteSpace: 'nowrap' }}>{tiempoRel(h.fecha)}</div>
            </div>
          ))}
        </div>

        <button
          onClick={() => { abrirAgente(agente.id); onClose(); }}
          style={{
            width: '100%', padding: '14px',
            background: agente.btnBg || 'rgba(255,255,255,0.18)',
            color: '#fff', border: 'none', borderRadius: 14,
            fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: PP,
          }}
        >
          💬 Hablar con {agente.nombre}
        </button>
      </div>
    </div>
  );
}

// ====== Componente principal ======

export default function CentroAgentes({ rol, nombre, onNavegar }) {
  const [tick, setTick] = useState(0);
  const [ancho, setAncho] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);
  const [modal, setModal] = useState(null);

  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 30000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const h = () => setAncho(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);

  const movil = ancho < 768;

  const datos = useMemo(() => {
    const d = {};
    AGENTES.forEach(a => { d[a.id] = generarEstado(a.id); });
    return d;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tick]);

  if (!tieneAcceso(rol)) {
    return (
      <div style={{
        fontFamily: PP, padding: 32, textAlign: 'center',
        background: '#fff', borderRadius: 16,
        color: '#666',
      }}>
        <div style={{ fontSize: 42, marginBottom: 12 }}>🔒</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#333' }}>Acceso restringido</div>
        <div style={{ fontSize: 13, marginTop: 6 }}>El Centro de Agentes solo está disponible para Dirección.</div>
      </div>
    );
  }

  const beep = AGENTES.find(a => a.esCEO);
  const gerentes = AGENTES.filter(a => !a.esCEO && !a.esLuna);
  const luna = AGENTES.find(a => a.esLuna);

  return (
    <div style={{
      fontFamily: PP, padding: movil ? 12 : 22,
      maxWidth: '100%', overflowX: 'hidden', boxSizing: 'border-box',
    }}>
      <style>{ESTILOS_GLOBAL}</style>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <div>
          <div style={{ fontSize: movil ? 22 : 28, fontWeight: 800, color: '#1a1a1a' }}>Centro de agentes</div>
          <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>Tu equipo de IA en tiempo real</div>
        </div>
        <span style={{
          background: '#D1FAE5', color: '#065F46',
          padding: '6px 14px', borderRadius: 999,
          fontSize: 12, fontWeight: 800,
          display: 'inline-flex', alignItems: 'center', gap: 6,
          animation: 'pulse-ring 2s ease-out infinite',
        }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#10B981' }} />
          En vivo
        </span>
      </div>

      {/* CEO Beep ancho completo */}
      <div style={{ marginBottom: 14 }}>
        <CardAgente agente={beep} data={datos.beep} animDelay={0} movil={movil} onAbrirModal={setModal} onNavegar={onNavegar} />
      </div>

      {/* Grid 2 columnas para gerentes (1 col en móvil) */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: movil ? '1fr' : '1fr 1fr',
        gap: 14, marginBottom: 14,
      }}>
        {gerentes.map((a, i) => (
          <CardAgente key={a.id} agente={a} data={datos[a.id]} animDelay={i * 0.25} movil={movil} onAbrirModal={setModal} onNavegar={onNavegar} />
        ))}
      </div>

      {/* Luna ancho completo */}
      <CardAgente agente={luna} data={datos.luna} animDelay={0.6} movil={movil} onAbrirModal={setModal} onNavegar={onNavegar} />

      {modal && <ModalAgente agente={modal} onClose={() => setModal(null)} movil={movil} />}
    </div>
  );
}
